import { css } from '@emotion/react';
import { formatDateTime, REACT_PRINT_STYLES } from '@kaiizen/kai-reports';
import { TradeHeader } from './TradeHeader';

const PAGE_SPACING_STYLE = css`
  margin-bottom: 40px;

  @media print {
    margin-bottom: 0;
  }
`;

type TaskPhoto = { id: string; dataUrl: string; createdAt?: string };

export const PhotosPage = ({
  tradeName,
  photos,
  groupRoomArea,
  groupTotal,
  groupId,
}: {
  tradeName: string;
  photos: Array<{ taskName: string; taskPhotos: TaskPhoto[] }>;
  groupRoomArea?: number;
  groupTotal?: number;
  groupId: string;
}) => {
  const flatPhotos = photos.flatMap(p => p.taskPhotos.map(taskPhoto => ({ taskName: p.taskName, taskPhoto })));
  if (flatPhotos.length === 0) return null;

  return (
    <div css={[REACT_PRINT_STYLES.page, PAGE_SPACING_STYLE]}>
      <TradeHeader
        tradeName={tradeName}
        groupRoomArea={groupRoomArea}
        groupTotal={groupTotal}
        groupId={groupId}
      />
      <div css={REACT_PRINT_STYLES.headRow}>Photos ({flatPhotos.length})</div>
      <div css={REACT_PRINT_STYLES.threeColGrid}>
        {flatPhotos.map((photo, index) => (
          <div key={`${photo.taskPhoto.id}-${index}`} css={REACT_PRINT_STYLES.borderBox}>
            <div
              css={REACT_PRINT_STYLES.groupImage}
              style={{ backgroundImage: `url('${photo.taskPhoto.dataUrl}')` }}
            />
            <div css={[REACT_PRINT_STYLES.borderBoxLabel, REACT_PRINT_STYLES.bold]} style={{ color: '#1D1D1D' }}>
              {photo.taskName}
            </div>
            <div>{formatDateTime(photo.taskPhoto.createdAt || '')}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
